import { render, staticRenderFns } from "./EngineRevisionsList.vue?vue&type=template&id=ca84a54e&scoped=true"
import script from "./EngineRevisionsList.vue?vue&type=script&lang=js"
export * from "./EngineRevisionsList.vue?vue&type=script&lang=js"
import style0 from "./EngineRevisionsList.vue?vue&type=style&index=0&id=ca84a54e&prod&lang=scss&scoped=true"
import style1 from "./EngineRevisionsList.vue?vue&type=style&index=1&id=ca84a54e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca84a54e",
  null
  
)

export default component.exports